import axios from './AxiosInstance'

export default {
  sendMailValidation: ({ name, email, userID }) => {
    console.log('in api, user.mailValidation, name:' + name + ' email:' + email)
    var formData = new FormData()
    formData.append('name', name)
    formData.append('email', email)
    if (userID) {
      formData.append('user_id', userID)
    }
    return new Promise((resolve, reject) => {
      axios.currentCsrfToken().then(token => {
        // console.log(token)
        axios.httpClient({
          method: 'post',
          url: '/api/user_mail_validation',
          headers: {
            'X-HTTP-Method-Override': 'POST',
            'Content-Type': 'multipart/form-data',
            'X-CSRF-TOKEN': token
          },
          withCredentials: true,
          data: formData
        }).then(res => {
          console.log(res)
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      }).catch(err => { reject(err) })
    })
  },

  createWithDevice: ({ formData }) => {
    return new Promise((resolve, reject) => {
      axios.currentCsrfToken().then(token => {
        axios.httpClient({
          method: 'post',
          url: '/api/user/create_with_device',
          headers: {
            'X-HTTP-Method-Override': 'POST',
            'Content-Type': 'multipart/form-data',
            'X-CSRF-TOKEN': token
          },
          withCredentials: true,
          data: formData
        }).then(res => {
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      }).catch(err => { reject(err) })
    })
  },

  createPhoneDevice: ({ formData }) => {
    return new Promise((resolve, reject) => {
      axios.currentCsrfToken().then(token => {
        axios.httpClient({
          method: 'post',
          url: '/api/user/create_phone_device',
          headers: {
            'X-HTTP-Method-Override': 'POST',
            'Content-Type': 'multipart/form-data',
            'X-CSRF-TOKEN': token
          },
          withCredentials: true,
          data: formData
        }).then(res => {
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      }).catch(err => { reject(err) })
    })
  },

  signin: ({ accountName, password }) => {
    return new Promise((resolve, reject) => {
      var formData = new FormData()
      formData.append('login_id', accountName)
      formData.append('password', password)
      axios.currentCsrfToken().then(token => {
        axios.httpClient({
          method: 'post',
          url: '/api/authenticate/user_signin',
          headers: {
            'X-HTTP-Method-Override': 'POST',
            'Content-Type': 'multipart/form-data',
            'X-CSRF-TOKEN': token
          },
          withCredentials: true,
          data: formData
        }).then(res => {
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      }).catch(err => { reject(err) })
    })
  },

  users_by_nb_signin: () => {
    return new Promise((resolve, reject) => {
      axios.httpClient({
        method: 'get',
        url: '/api/authenticate/nb_account_selection',
        headers: {
          'X-HTTP-Method-Override': 'GET',
        },
        withCredentials: true
      }).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },

  signin_with_nb_sso: ({ user_id }) => {
    return new Promise((resolve, reject) => {
      var formData = new FormData()
      formData.append('user_id', user_id)
      axios.currentCsrfToken().then(token => {
        axios.httpClient({
          method: 'post',
          url: '/api/authenticate/signin_with_nb_sso',
          headers: {
            'X-HTTP-Method-Override': 'POST',
            'Content-Type': 'multipart/form-data',
            'X-CSRF-TOKEN': token
          },
          withCredentials: true,
          data: formData
        }).then(res => {
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      }).catch(err => { reject(err) })
    })
  },

  signout: () => {
    return new Promise((resolve, reject) => {
      axios.currentCsrfToken().then(token => {
        axios.httpClient({
          method: 'delete',
          url: '/api/authenticate/signout',
          headers: {
            'X-HTTP-Method-Override': 'DELETE',
            'Content-Type': 'multipart/form-data',
            'X-CSRF-TOKEN': token
          },
          withCredentials: true,
        }).then(res => {
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      }).catch(err => { reject(err) })
    })
  },

  switchAccount: ({ accountName }) => {
    return new Promise((resolve, reject) => {
      var formData = new FormData()
      formData.append('login_id', accountName)
      axios.currentCsrfToken().then(token => {
        axios.httpClient({
          method: 'put',
          url: '/api/authenticate/switch_account',
          headers: {
            'X-HTTP-Method-Override': 'PUT',
            'Content-Type': 'multipart/form-data',
            'X-CSRF-TOKEN': token
          },
          withCredentials: true,
          data: formData
        }).then(res => {
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      }).catch(err => { reject(err) })
    })
  },

  fetch: () => {
    return new Promise((resolve, reject) => {
      axios.httpClient({
        method: 'get',
        url: '/api/user',
        headers: {
          'X-HTTP-Method-Override': 'GET',
        },
        withCredentials: true
      }).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },

  fetchCurrentSignin: () => {
    return new Promise((resolve, reject) => {
      axios.httpClient({
        method: 'get',
        url: '/api/authenticate/current_signin_user_and_device',
        headers: {
          'X-HTTP-Method-Override': 'GET',
        },
        withCredentials: true
      }).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },

  fetchAvailabeUsers: () => {
    return new Promise((resolve, reject) => {
      axios.httpClient({
        method: 'get',
        url: '/api/user/list_by_device',
        headers: {
          'X-HTTP-Method-Override': 'GET',
        },
        withCredentials: true
      }).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },

  fetchByNarrativePhoneID: ({ narrativePhoneID }) => {
    return new Promise((resolve, reject) => {
      axios.httpClient({
        method: 'get',
        url: '/api/user/by_narrative_phone_id',
        headers: {
          'X-HTTP-Method-Override': 'GET',
        },
        params: { narrative_phone_id: narrativePhoneID },
        withCredentials: true
      }).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // sendMailValidation: ({ email }) => {
  //   return new Promise((resolve, reject) => {
  //     var formData = new FormData()
  //     formData.append('email', email)
  //     axios.currentCsrfToken().then(token => {
  //       axios.httpClient({
  //         method: 'put',
  //         url: '/api/user',
  //         headers: {
  //           'X-HTTP-Method-Override': 'PUT',
  //           'Content-Type': 'multipart/form-data',
  //           'X-CSRF-TOKEN': token
  //         },
  //         withCredentials: true,
  //         data: formData
  //       }).then(res => {
  //         resolve(res)
  //       }).catch(error => {
  //         reject(error)
  //       })
  //     })
  //   })
  // },

  nameAvailable: ({ accountName }) => {
    return new Promise((resolve, reject) => {
      axios.httpClient({
        method: 'get',
        url: '/api/user/name_available',
        headers: {
          'X-HTTP-Method-Override': 'GET',
        },
        params: { account_name: accountName },
        withCredentials: true
      }).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },

  relateNBAccount: ({ formData }) => {
    return new Promise((resolve, reject) => {
      axios.currentCsrfToken().then(token => {
        axios.httpClient({
          method: 'put',
          url: '/api/user/create_nb_relation',
          headers: {
            'X-HTTP-Method-Override': 'PUT',
            'Content-Type': 'multipart/form-data',
            'X-CSRF-TOKEN': token
          },
          withCredentials: true,
          data: formData
        }).then(res => {
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      }).catch(err => { reject(err) })
    })
  },

  update: ({ formData }) => {
    return new Promise((resolve, reject) => {
      axios.currentCsrfToken().then(token => {
        axios.httpClient({
          method: 'put',
          url: '/api/user',
          headers: {
            'X-HTTP-Method-Override': 'PUT',
            'Content-Type': 'multipart/form-data',
            'X-CSRF-TOKEN': token
          },
          withCredentials: true,
          data: formData
        }).then(res => {
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      }).catch(err => { reject(err) })
    })
  },

  updatePassword: ({ password, passwordConfirmation}) => {
    return new Promise((resolve, reject) => {
      var formData = new FormData()
      formData.append('password', password)
      formData.append('password_confirmation', passwordConfirmation)
      axios.currentCsrfToken().then(token => {
        axios.httpClient({
          method: 'put',
          url: '/api/user/update_password',
          headers: {
            'X-HTTP-Method-Override': 'PUT',
            'Content-Type': 'multipart/form-data',
            'X-CSRF-TOKEN': token
          },
          withCredentials: true,
          data: formData
        }).then(res => {
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      }).catch(err => { reject(err) })
    })
  },

  destroy: () => {
    return new Promise((resolve, reject) => {
      axios.currentCsrfToken().then(token => {
        axios.httpClient({
          method: 'delete',
          url: '/api/user',
          headers: {
            'X-HTTP-Method-Override': 'DELETE',
            'Content-Type': 'multipart/form-data',
            'X-CSRF-TOKEN': token
          },
          withCredentials: true,
        }).then(res => {
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      }).catch(err => { reject(err) })
    })
  },

  account_result: ({code}) => {
    return new Promise((resolve, reject) => {
      axios.httpClient({
        method: 'get',
        url: '/api/user/select_account_result',
        headers: {
          'X-HTTP-Method-Override': 'GET',
        },
        withCredentials: true,
        params: { code: code }
      }).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },

  fetch_narrativebook_account: () => {
    return new Promise((resolve, reject) => {
      axios.httpClient({
        method: 'get',
        url: '/api/user/narrativebook_account',
        headers: {
          'X-HTTP-Method-Override': 'GET',
        },
        withCredentials: true,
      }).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },

  update_narrativebook_account: () => {
    return new Promise((resolve, reject) => {
      axios.currentCsrfToken().then(token => {
        axios.httpClient({
          method: 'put',
          url: '/api/user/connect_narrativebook',
          headers: {
            'X-HTTP-Method-Override': 'PUT',
            'Content-Type': 'multipart/form-data',
            'X-CSRF-TOKEN': token
          },
          withCredentials: true,
        }).then(res => {
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      }).catch(err => { reject(err) })
    })
  },

  delete_device_relation: ({ targetDeviceID }) => {
    return new Promise((resolve, reject) => {
      axios.currentCsrfToken().then(token => {
        axios.httpClient({
          method: 'delete',
          url: '/api/user/delete_device_relation',
          headers: {
            'X-HTTP-Method-Override': 'DELETE',
            'X-CSRF-TOKEN': token
          },
          withCredentials: true,
          params: { target_device_id: targetDeviceID }
        }).then(res => {
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      }).catch(err => { reject(err) })
    })
  },

  revoke_zoom: () => {
    return new Promise((resolve, reject) => {
      axios.currentCsrfToken().then(token => {
        axios.httpClient({
          method: 'delete',
          url: '/api/user/revoke_zoom',
          headers: {
            'X-HTTP-Method-Override': 'DELETE',
            'Content-Type': 'multipart/form-data',
            'X-CSRF-TOKEN': token
          },
          withCredentials: true,
        }).then(res => {
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      }).catch(err => { reject(err) })
    })
  }

}